<span *ngIf="overdueAction != 0" class="badge badge-danger">{{overdueAction}}</span>

